const isPasswordAlpa = data => {

  let value = data.value
  const key = 'isPasswordAlpa'
  value = value.trim()

  const pattern = /(?=.*?[A-Z])/
  const isTestOk = pattern.test(value) ? true : false
  const error = isTestOk ? false : key
  return error ? { error, data } : false
}

export default isPasswordAlpa
